export default __webpack_public_path__ + "static/pic05-93db7731153e50e43c0ea9ba81982e26.jpg";